import moment from "moment";
import React from "react";

export function GochiKidSurveyGroupUserResultModal(props) {
  return (
    <>
      <div
        className={
          props.showing
            ? "custom-modal-container group-special-gochi-kid-modal gochi-kid-banner-detail-modal show-modal"
            : "custom-modal-container group-special-gochi-kid-modal"
        }
        size="sm"
      >
        <div
          className={
            props.showing
              ? "modal modal-action modal-dialog is-show history-modal max-width-335"
              : "modal modal-action modal-dialog history-modal max-width-335"
          }
        >
          <div className="title-modal title-modal-charge">
            <div className="title">{props.isPass ? "応募完了 & ご当選" : "応募完了(今回はお見送り)"}</div>
          </div>
          <div className={`modal-body fs-16`}>
            {props.isPass ? (
              <div>
                <div>ご応募いただき、誠にありがとうございました！</div>
                <br />
                <div>
                  審査を行わせていただきました結果、
                  {props.bannerDetail?.gochiKidGroupName}
                  のモニターとしてご参加いただくこととなりました。
                </div>
                <br />
                <div>
                  {props.bannerDetail?.gochiKidGroupName}の開始日(
                  {props.bannerDetail?.startTime
                    ? moment(props.bannerDetail?.startTime).format(
                        "YYYY年MM月DD日",
                      )
                    : ""}
                  )より、こどもごちめし利用マイページの"店舗・メニューを探す"ボタンからご利用ください。
                </div>
                <br />
                <div>
                  そして、"支援元を選ぶ"画面に表示される支援元の
                  {props.bannerDetail?.gochiKidGroupName}
                  をご選択の上、店舗検索、及びメニュー選択へお進みください。
                </div>
              </div>
            ) : (
              <div>
                <div>
                  この度は、モニターにご応募いただき誠にありがとうございます。
                </div>
                <br />
                <div>
                  想定を上回る多数のご応募をいただき、誠に残念ながら今回はご希望に添いかねる結果となりました。
                </div>
                <br />
                <div>
                  またの機会がございましたら、何卒よろしくお願い申し上げます。
                </div>
              </div>
            )}
          </div>
          <div className="modal-footer mt-24px">
            <div>
              <button
                onClick={() => props.handleClose()}
                className="btn btn-rect btn-survey my-0"
              >
                マイページに戻る
              </button>
            </div>
          </div>
        </div>
        <div
          onClick={() => props.handleClose()}
          className={`back-drop ${
            props.accessToken && props.accessCode ? "back-drop-bold" : ""
          }`}
        />
      </div>
    </>
  );
}
